import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SessionUserHashManagerService } from '../../_services/session-user-hash-manager/session-user-hash-manager.service';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { ManualAddModalComponent } from '../../students/add-student/manual-add-modal/manual-add-modal.component';
import { StudentMaintenanceService } from '../../_services/student-maintenance/student-maintenance.service';
import { StudentSearchComponent } from '../../shared/student-search/student-search.component';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-client-students',
    templateUrl: './client-students.component.html',
    styleUrls: ['./client-students.component.css'],
    standalone: false
})
export class ClientStudentsComponent implements OnInit, OnDestroy {
  @ViewChild("studentSearch", { static: false }) studentSearchComponent: StudentSearchComponent;

  public clientId: number;

  public hasStudentDataInsertPermission: boolean = false;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public themeService: ThemeService,
    public dialog: MatDialog,
    private featureHelperService: FeatureHelperService,
    private router: Router,
    private route: ActivatedRoute,
    private userHashManager: SessionUserHashManagerService,
    private studentMaintenanceService: StudentMaintenanceService,
    private authenticationStateHelper: AuthenticationStateHelperService
    ) { 
      this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
        if (!params['clientId']) {
          this.router.navigate(['/login']);
        } else {
          this.userHashManager.checkUserForExternal();

          this.themeService.setActiveTheme('LEAP');

          let featureList = new Array<string>();
          featureList.push(
            "StudentDataSearch",
            "StudentDataInsert");

          let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

          if (!currentUserFeatures.filter(f => f.feature === "StudentDataSearch")[0].enabled) {
            console.error("User does not have the required permissions to view Student Search");
            this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
            this.authenticationStateHelper.unauthorizedToken = true;
          }

          if (currentUserFeatures.filter(f => f.feature === "StudentDataInsert")[0].enabled) {
            this.hasStudentDataInsertPermission = true;
          }

          this.clientId = +params['clientId'];
         
          setTimeout(() => {
            this.studentSearchComponent.search();
          }, 100);
          
        }
      });
    }

  ngOnInit() {
    
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public addStudent(): void {
    this.studentMaintenanceService.studentId = 0;
      const dialogRef = this.dialog.open(ManualAddModalComponent, {
        panelClass: 'my-dialog'
    });
  }

}
